/**
 * @generated SignedSource<<278b272c2f1c1515ff41257b8079a3d9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TrackViewEvent = "DIRECT" | "INDIRECT" | "SKIP";
export type GoalViewAsideQuery$variables = {
  containerId: string;
  key: string;
  teamTql?: string | null;
  trackViewEvent?: TrackViewEvent | null;
};
export type GoalViewAsideQuery$data = {
  readonly goal: {
    readonly ari: string;
    readonly owner: {
      readonly aaid: string | null;
    } | null;
    readonly watchers: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly aaid: string | null;
        } | null;
      } | null> | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"GoalMetaActions" | "GoalSidebar">;
  } | null;
  readonly workspaceGoalTypes: {
    readonly goalTypes: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: "GoalType";
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"metricInfoSectionNewLozenge">;
};
export type GoalViewAsideQuery = {
  response: GoalViewAsideQuery$data;
  variables: GoalViewAsideQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamTql"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "trackViewEvent"
},
v4 = [
  {
    "kind": "Variable",
    "name": "containerId",
    "variableName": "containerId"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  },
  {
    "kind": "Variable",
    "name": "trackViewEvent",
    "variableName": "trackViewEvent"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "ari"
},
v8 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v9 = [
  (v8/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = {
  "kind": "ScalarField",
  "name": "name"
},
v12 = {
  "kind": "ScalarField",
  "name": "picture"
},
v13 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v14 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v15 = [
  {
    "concreteType": "UserEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v10/*: any*/)
        ]
      }
    ]
  }
],
v16 = {
  "kind": "ScalarField",
  "name": "key"
},
v17 = {
  "kind": "ScalarField",
  "name": "value"
},
v18 = {
  "kind": "ScalarField",
  "name": "score"
},
v19 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v20 = {
  "kind": "ScalarField",
  "name": "watching"
},
v21 = {
  "kind": "ScalarField",
  "name": "archived"
},
v22 = {
  "kind": "ScalarField",
  "name": "accessLevel"
},
v23 = {
  "concreteType": "GoalIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    {
      "kind": "ScalarField",
      "name": "appearance"
    }
  ]
},
v24 = {
  "kind": "ScalarField",
  "name": "type"
},
v25 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v26 = {
  "concreteType": "GoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v24/*: any*/),
    (v25/*: any*/)
  ]
},
v27 = {
  "concreteType": "MetricValue",
  "kind": "LinkedField",
  "name": "snapshotValue",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v10/*: any*/)
  ]
},
v28 = {
  "kind": "ScalarField",
  "name": "startValue"
},
v29 = {
  "kind": "ScalarField",
  "name": "targetValue"
},
v30 = {
  "kind": "ScalarField",
  "name": "subType"
},
v31 = {
  "kind": "ScalarField",
  "name": "source"
},
v32 = {
  "kind": "ScalarField",
  "name": "time"
},
v33 = [
  (v32/*: any*/),
  (v10/*: any*/)
],
v34 = {
  "concreteType": "MetricTargetConnection",
  "kind": "LinkedField",
  "name": "metricTargets",
  "plural": false,
  "selections": [
    {
      "concreteType": "MetricTargetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "MetricTarget",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v27/*: any*/),
            (v28/*: any*/),
            (v29/*: any*/),
            {
              "concreteType": "Metric",
              "kind": "LinkedField",
              "name": "metric",
              "plural": false,
              "selections": [
                (v24/*: any*/),
                (v30/*: any*/),
                (v10/*: any*/),
                (v11/*: any*/),
                (v21/*: any*/),
                (v31/*: any*/),
                {
                  "concreteType": "MetricValue",
                  "kind": "LinkedField",
                  "name": "latestValue",
                  "plural": false,
                  "selections": (v33/*: any*/)
                }
              ]
            },
            (v10/*: any*/)
          ]
        }
      ]
    }
  ]
},
v35 = {
  "kind": "ScalarField",
  "name": "count"
},
v36 = [
  (v35/*: any*/)
],
v37 = {
  "concreteType": "GoalConnection",
  "kind": "LinkedField",
  "name": "subGoals",
  "plural": false,
  "selections": (v36/*: any*/)
},
v38 = [
  (v17/*: any*/)
],
v39 = {
  "kind": "ScalarField",
  "name": "messageId"
},
v40 = {
  "kind": "InlineFragment",
  "selections": [
    (v39/*: any*/),
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "LocalizationField"
},
v41 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v38/*: any*/),
      "type": "GoalTypeCustomName"
    },
    (v40/*: any*/)
  ]
},
v42 = {
  "kind": "ScalarField",
  "name": "kind"
},
v43 = {
  "kind": "ScalarField",
  "name": "requiresParentGoal"
},
v44 = {
  "args": [
    {
      "kind": "Literal",
      "name": "includeScore",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(includeScore:false)"
},
v45 = [
  (v39/*: any*/)
],
v46 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v45/*: any*/)
},
v47 = {
  "kind": "ScalarField",
  "name": "label"
},
v48 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v49 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "dueDate",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "confidence"
    },
    (v47/*: any*/),
    (v46/*: any*/),
    {
      "alias": "tooltip",
      "args": (v48/*: any*/),
      "kind": "ScalarField",
      "name": "label",
      "storageKey": "label(longFormat:true)"
    },
    {
      "alias": "localizedTooltip",
      "args": (v48/*: any*/),
      "concreteType": "LocalizationField",
      "kind": "LinkedField",
      "name": "localizedLabel",
      "plural": false,
      "selections": (v45/*: any*/),
      "storageKey": "localizedLabel(longFormat:true)"
    },
    {
      "kind": "ScalarField",
      "name": "overdue"
    }
  ]
},
v50 = {
  "concreteType": "UserPII",
  "kind": "LinkedField",
  "name": "pii",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v14/*: any*/)
  ]
},
v51 = {
  "kind": "ScalarField",
  "name": "__id"
},
v52 = {
  "kind": "ClientExtension",
  "selections": [
    (v51/*: any*/)
  ]
},
v53 = {
  "alias": "connectionId",
  "kind": "ScalarField",
  "name": "__id"
},
v54 = {
  "kind": "LinkedField",
  "name": "namePlural",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v38/*: any*/),
      "type": "GoalTypeCustomNamePlural"
    },
    (v40/*: any*/)
  ]
},
v55 = {
  "concreteType": "GoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v16/*: any*/)
  ]
},
v56 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v57 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v58 = {
  "kind": "ScalarField",
  "name": "description"
},
v59 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v60 = {
  "kind": "LinkedField",
  "name": "definition",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v11/*: any*/),
        (v58/*: any*/)
      ],
      "type": "CustomFieldDefinitionNode",
      "abstractKey": "__isCustomFieldDefinitionNode"
    },
    (v59/*: any*/)
  ]
},
v61 = {
  "kind": "InlineFragment",
  "selections": [
    (v24/*: any*/)
  ],
  "type": "CustomFieldDefinitionNode",
  "abstractKey": "__isCustomFieldDefinitionNode"
},
v62 = {
  "kind": "ScalarField",
  "name": "canSetMultipleValues"
},
v63 = [
  (v62/*: any*/)
],
v64 = {
  "kind": "InlineFragment",
  "selections": (v63/*: any*/),
  "type": "UserCustomFieldDefinition"
},
v65 = {
  "kind": "InlineFragment",
  "selections": (v63/*: any*/),
  "type": "TextSelectCustomFieldDefinition"
},
v66 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "LinkedField",
      "name": "definition",
      "plural": false,
      "selections": [
        (v61/*: any*/),
        (v64/*: any*/),
        (v65/*: any*/)
      ]
    }
  ],
  "type": "CustomFieldNode",
  "abstractKey": "__isCustomFieldNode"
},
v67 = {
  "kind": "ClientExtension",
  "selections": [
    (v53/*: any*/)
  ]
},
v68 = [
  (v10/*: any*/),
  (v17/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalViewAsideQuery",
    "selections": [
      {
        "alias": "workspaceGoalTypes",
        "concreteType": "Townsquare",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "GoalTypeConnection",
            "kind": "LinkedField",
            "name": "goalTypes",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "GoalType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "goal",
        "args": (v6/*: any*/),
        "concreteType": "Goal",
        "kind": "LinkedField",
        "name": "goalByKey",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": (v9/*: any*/)
          },
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": [
              {
                "concreteType": "UserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v9/*: any*/)
                  }
                ]
              }
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "GoalMetaActions"
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "teamTql",
                "variableName": "teamTql"
              }
            ],
            "kind": "FragmentSpread",
            "name": "GoalSidebar"
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "metricInfoSectionNewLozenge"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalViewAsideQuery",
    "selections": [
      {
        "alias": "workspaceGoalTypes",
        "concreteType": "Townsquare",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "GoalTypeConnection",
            "kind": "LinkedField",
            "name": "goalTypes",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "GoalType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v10/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "goal",
        "args": (v6/*: any*/),
        "concreteType": "Goal",
        "kind": "LinkedField",
        "name": "goalByKey",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v10/*: any*/),
              {
                "concreteType": "UserPII",
                "kind": "LinkedField",
                "name": "pii",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "email"
                  },
                  (v14/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": (v15/*: any*/)
          },
          (v16/*: any*/),
          (v10/*: any*/),
          {
            "kind": "ScalarField",
            "name": "canPostUpdate"
          },
          {
            "concreteType": "GoalState",
            "kind": "LinkedField",
            "name": "state",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              (v18/*: any*/),
              {
                "concreteType": "CompletionGoalState",
                "kind": "LinkedField",
                "name": "atCompletionState",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v18/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "targetDate"
          },
          {
            "kind": "ScalarField",
            "name": "targetDateConfidence"
          },
          (v19/*: any*/),
          (v20/*: any*/),
          {
            "concreteType": "TownsquareGoalCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canWatchGoal"
              },
              {
                "kind": "ScalarField",
                "name": "canArchiveGoal"
              },
              {
                "kind": "ScalarField",
                "name": "canCreateUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canEditMetadata"
              }
            ]
          },
          (v11/*: any*/),
          (v21/*: any*/),
          {
            "concreteType": "Goal",
            "kind": "LinkedField",
            "name": "parentGoal",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              (v7/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v26/*: any*/),
              (v34/*: any*/),
              (v37/*: any*/),
              (v16/*: any*/),
              {
                "concreteType": "GoalType",
                "kind": "LinkedField",
                "name": "goalType",
                "plural": false,
                "selections": [
                  (v41/*: any*/),
                  (v42/*: any*/),
                  (v10/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "subGoals",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v21/*: any*/),
                      (v10/*: any*/),
                      {
                        "concreteType": "GoalType",
                        "kind": "LinkedField",
                        "name": "goalType",
                        "plural": false,
                        "selections": [
                          (v42/*: any*/),
                          (v10/*: any*/),
                          (v43/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "GoalProgress",
                        "kind": "LinkedField",
                        "name": "progress",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          (v24/*: any*/)
                        ]
                      },
                      (v19/*: any*/),
                      (v16/*: any*/),
                      (v23/*: any*/),
                      (v11/*: any*/),
                      (v34/*: any*/),
                      (v37/*: any*/),
                      (v22/*: any*/),
                      {
                        "concreteType": "TownsquareGoalCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "canAddLinkedProjects"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canRemoveLinkedProjects"
                          }
                        ]
                      },
                      {
                        "concreteType": "GoalState",
                        "kind": "LinkedField",
                        "name": "state",
                        "plural": false,
                        "selections": [
                          (v44/*: any*/),
                          (v46/*: any*/),
                          (v18/*: any*/),
                          (v17/*: any*/),
                          {
                            "concreteType": "CompletionGoalState",
                            "kind": "LinkedField",
                            "name": "atCompletionState",
                            "plural": false,
                            "selections": [
                              (v44/*: any*/),
                              (v46/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v49/*: any*/),
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v50/*: any*/),
                          (v10/*: any*/)
                        ]
                      },
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 200
                          },
                          {
                            "kind": "Literal",
                            "name": "tql",
                            "value": "archived = false"
                          }
                        ],
                        "concreteType": "ProjectConnection",
                        "kind": "LinkedField",
                        "name": "projects",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "ProjectEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Project",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "concreteType": "ProjectPhaseDetails",
                                    "kind": "LinkedField",
                                    "name": "newPhase",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": "_id",
                                        "kind": "ScalarField",
                                        "name": "id"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "owner",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v8/*: any*/),
                                      (v50/*: any*/)
                                    ]
                                  },
                                  (v16/*: any*/),
                                  (v11/*: any*/),
                                  (v19/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "private"
                                  },
                                  {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "shortName"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "IconURIs",
                                    "kind": "LinkedField",
                                    "name": "iconUrl",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "ThemeURIs",
                                        "kind": "LinkedField",
                                        "name": "square",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "light"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "dark"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "transparent"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v49/*: any*/),
                                  {
                                    "concreteType": "ProjectState",
                                    "kind": "LinkedField",
                                    "name": "state",
                                    "plural": false,
                                    "selections": [
                                      (v47/*: any*/),
                                      (v46/*: any*/),
                                      (v17/*: any*/),
                                      {
                                        "concreteType": "CompletionProjectState",
                                        "kind": "LinkedField",
                                        "name": "atCompletionState",
                                        "plural": false,
                                        "selections": [
                                          (v17/*: any*/),
                                          (v47/*: any*/),
                                          (v46/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  (v21/*: any*/),
                                  {
                                    "concreteType": "UserConnection",
                                    "kind": "LinkedField",
                                    "name": "members",
                                    "plural": false,
                                    "selections": (v15/*: any*/)
                                  }
                                ]
                              },
                              (v52/*: any*/)
                            ]
                          },
                          (v52/*: any*/)
                        ],
                        "storageKey": "projects(first:200,tql:\"archived = false\")"
                      }
                    ]
                  }
                ]
              },
              (v35/*: any*/),
              {
                "kind": "ClientExtension",
                "selections": [
                  (v51/*: any*/),
                  (v53/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "GoalType",
            "kind": "LinkedField",
            "name": "goalType",
            "plural": false,
            "selections": [
              (v42/*: any*/),
              {
                "concreteType": "GoalType",
                "kind": "LinkedField",
                "name": "successMeasure",
                "plural": false,
                "selections": [
                  (v41/*: any*/),
                  (v54/*: any*/),
                  (v10/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "state"
                  }
                ]
              },
              (v10/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canLinkToFocusArea"
              },
              {
                "concreteType": "GoalTypeConnection",
                "kind": "LinkedField",
                "name": "allowedParentTypes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GoalTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "GoalType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v41/*: any*/),
                          (v55/*: any*/),
                          (v43/*: any*/),
                          (v10/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "GoalTypeConnection",
                "kind": "LinkedField",
                "name": "allowedChildTypes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GoalTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "GoalType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v41/*: any*/),
                          (v55/*: any*/),
                          (v43/*: any*/),
                          (v10/*: any*/),
                          (v42/*: any*/),
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v43/*: any*/),
              (v41/*: any*/),
              (v55/*: any*/)
            ]
          },
          {
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 50
              }
            ],
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "successMeasures",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v21/*: any*/),
                      (v10/*: any*/),
                      (v26/*: any*/),
                      {
                        "concreteType": "GoalType",
                        "kind": "LinkedField",
                        "name": "goalType",
                        "plural": false,
                        "selections": [
                          (v41/*: any*/),
                          (v54/*: any*/),
                          (v10/*: any*/),
                          (v42/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v56/*: any*/)
                ]
              }
            ],
            "storageKey": "successMeasures(first:50)"
          },
          (v26/*: any*/),
          {
            "concreteType": "MetricTargetConnection",
            "kind": "LinkedField",
            "name": "metricTargets",
            "plural": false,
            "selections": [
              {
                "concreteType": "MetricTargetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "MetricTarget",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "Metric",
                        "kind": "LinkedField",
                        "name": "metric",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v10/*: any*/),
                          (v24/*: any*/),
                          (v30/*: any*/),
                          (v11/*: any*/),
                          (v31/*: any*/),
                          {
                            "concreteType": "MetricValue",
                            "kind": "LinkedField",
                            "name": "latestValue",
                            "plural": false,
                            "selections": [
                              (v32/*: any*/),
                              (v10/*: any*/),
                              (v17/*: any*/)
                            ]
                          },
                          (v7/*: any*/),
                          (v19/*: any*/)
                        ]
                      },
                      (v10/*: any*/),
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v7/*: any*/),
                      {
                        "concreteType": "MetricTargetPeriodConnection",
                        "kind": "LinkedField",
                        "name": "metricTargetPeriods",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "MetricTargetPeriodEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "MetricTargetPeriod",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TargetDate",
                                    "kind": "LinkedField",
                                    "name": "date",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TargetDateRange",
                                        "kind": "LinkedField",
                                        "name": "dateRange",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "start"
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v17/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v22/*: any*/),
          {
            "concreteType": "GoalUpdate",
            "kind": "LinkedField",
            "name": "latestUserUpdate",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalMetricUpdateConnection",
                "kind": "LinkedField",
                "name": "metricUpdate",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GoalMetricUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "GoalMetricUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "MetricValue",
                            "kind": "LinkedField",
                            "name": "newValue",
                            "plural": false,
                            "selections": (v33/*: any*/)
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v10/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "canEditMembers"
          },
          {
            "args": (v57/*: any*/),
            "concreteType": "GoalTeamConnection",
            "kind": "LinkedField",
            "name": "teamsV2",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalTeamEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "teamId"
                      },
                      (v11/*: any*/),
                      (v10/*: any*/),
                      (v20/*: any*/),
                      {
                        "concreteType": "TeamDetails",
                        "kind": "LinkedField",
                        "name": "teamDetails",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "isVerified"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "avatarUrl"
                      },
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "tql",
                            "variableName": "teamTql"
                          }
                        ],
                        "concreteType": "ProjectConnection",
                        "kind": "LinkedField",
                        "name": "projects",
                        "plural": false,
                        "selections": (v36/*: any*/)
                      },
                      (v5/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "canRemove"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  (v56/*: any*/)
                ]
              },
              (v52/*: any*/)
            ],
            "storageKey": "teamsV2(first:20)"
          },
          {
            "args": (v57/*: any*/),
            "handle": "connection",
            "key": "Goal__teamsV2",
            "kind": "LinkedHandle",
            "name": "teamsV2"
          },
          {
            "kind": "ScalarField",
            "name": "startDate"
          },
          {
            "kind": "ScalarField",
            "name": "creationDate"
          },
          {
            "concreteType": "TagConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "concreteType": "TagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Tag",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v19/*: any*/),
                      (v11/*: any*/),
                      (v58/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "projectUsageCount"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "goalUsageCount"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "helpPointerUsageCount"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "watcherCount"
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "alias": "tagConnectionId",
                    "kind": "ScalarField",
                    "name": "__id"
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "CustomFieldConnection",
            "kind": "LinkedField",
            "name": "customFields",
            "plural": false,
            "selections": [
              {
                "concreteType": "CustomFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v10/*: any*/),
                          (v60/*: any*/),
                          {
                            "concreteType": "CustomFieldTextSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": "textValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          (v66/*: any*/)
                        ],
                        "type": "TextCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v10/*: any*/),
                          (v60/*: any*/),
                          {
                            "concreteType": "CustomFieldNumberSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": "numberValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          (v66/*: any*/)
                        ],
                        "type": "NumberCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v10/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v11/*: any*/),
                                  (v58/*: any*/),
                                  (v62/*: any*/)
                                ],
                                "type": "UserCustomFieldDefinition"
                              },
                              (v59/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "UserConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "UserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v8/*: any*/),
                                      {
                                        "concreteType": "UserPII",
                                        "kind": "LinkedField",
                                        "name": "pii",
                                        "plural": false,
                                        "selections": [
                                          (v12/*: any*/),
                                          (v11/*: any*/),
                                          (v13/*: any*/),
                                          (v14/*: any*/),
                                          {
                                            "concreteType": "ExtendedProfile",
                                            "kind": "LinkedField",
                                            "name": "extendedProfile",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "jobTitle"
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v67/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "definition",
                                "plural": false,
                                "selections": [
                                  (v61/*: any*/),
                                  (v65/*: any*/)
                                ]
                              }
                            ],
                            "type": "CustomFieldNode",
                            "abstractKey": "__isCustomFieldNode"
                          }
                        ],
                        "type": "UserCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v10/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v11/*: any*/),
                                  (v58/*: any*/),
                                  (v62/*: any*/),
                                  {
                                    "concreteType": "CustomFieldTextAllowedValueConnection",
                                    "kind": "LinkedField",
                                    "name": "allowedValues",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "CustomFieldTextAllowedValueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "CustomFieldTextAllowedValueNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": (v68/*: any*/)
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "type": "TextSelectCustomFieldDefinition"
                              },
                              (v59/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "CustomFieldTextSavedValueConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "CustomFieldTextSavedValueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "CustomFieldTextSavedValueNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v68/*: any*/)
                                  }
                                ]
                              },
                              (v67/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "definition",
                                "plural": false,
                                "selections": [
                                  (v61/*: any*/),
                                  (v64/*: any*/)
                                ]
                              }
                            ],
                            "type": "CustomFieldNode",
                            "abstractKey": "__isCustomFieldNode"
                          }
                        ],
                        "type": "TextSelectCustomField"
                      },
                      (v59/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "keys": [
                    "GOALS_METRICS_POPUP"
                  ]
                }
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              }
            ],
            "concreteType": "OnboardingConnection",
            "kind": "LinkedField",
            "name": "onboarding",
            "plural": false,
            "selections": [
              {
                "concreteType": "OnboardingEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Onboarding",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v10/*: any*/)
                    ]
                  }
                ]
              }
            ],
            "storageKey": "onboarding(filter:{\"keys\":[\"GOALS_METRICS_POPUP\"]},first:1)"
          },
          (v10/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "1e1d9d58f91c56525c33abac2ede47ad",
    "id": null,
    "metadata": {},
    "name": "GoalViewAsideQuery",
    "operationKind": "query",
    "text": "query GoalViewAsideQuery(\n  $key: String!\n  $trackViewEvent: TrackViewEvent\n  $teamTql: String\n  $containerId: String!\n) {\n  workspaceGoalTypes: townsquare {\n    goalTypes(containerId: $containerId) {\n      edges {\n        node {\n          __typename\n          id\n        }\n      }\n    }\n  }\n  goal: goalByKey(key: $key, trackViewEvent: $trackViewEvent) {\n    ari\n    owner {\n      aaid\n      id\n    }\n    watchers {\n      edges {\n        node {\n          aaid\n          id\n        }\n      }\n    }\n    ...GoalMetaActions\n    ...GoalSidebar_1QTvbf\n    id\n  }\n  ...metricInfoSectionNewLozenge\n}\n\nfragment AddMetricButtonPopup on Goal {\n  ari\n  ...CreateOrSelectForm\n}\n\nfragment AddOrEditButton on CustomFieldNode {\n  __isCustomFieldNode: __typename\n  id\n  definition {\n    __typename\n    ... on CustomFieldDefinitionNode {\n      __isCustomFieldDefinitionNode: __typename\n      type\n    }\n    ... on UserCustomFieldDefinition {\n      canSetMultipleValues\n    }\n    ... on TextSelectCustomFieldDefinition {\n      canSetMultipleValues\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment ArchiveGoal_goalActions on Goal {\n  id\n  name\n  archived\n  parentGoal {\n    id\n    name\n  }\n  subGoals {\n    edges {\n      node {\n        archived\n        id\n      }\n    }\n  }\n  goalType {\n    kind\n    successMeasure {\n      ...goalTypeNamePlural\n      id\n    }\n    id\n  }\n  successMeasures(first: 50) {\n    edges {\n      node {\n        archived\n        id\n      }\n    }\n  }\n}\n\nfragment ChangeRollupTypePopup on Goal {\n  ...ChangeRollupTypeWarning\n  id\n  goalType {\n    successMeasure {\n      state\n      id\n    }\n    id\n  }\n  progress {\n    type\n  }\n  subGoals {\n    edges {\n      node {\n        goalType {\n          kind\n          id\n        }\n        archived\n        id\n      }\n    }\n  }\n  successMeasures(first: 50) {\n    edges {\n      node {\n        progress {\n          type\n        }\n        archived\n        id\n      }\n    }\n  }\n}\n\nfragment ChangeRollupTypeWarning on Goal {\n  id\n  progress {\n    type\n    percentage\n  }\n  goalType {\n    successMeasure {\n      state\n      id\n    }\n    id\n  }\n}\n\nfragment CompactGoalSummaryPanel on Goal {\n  ...GoalName\n  state {\n    ...GoalState\n  }\n  ...progressBarMetricTarget\n  ...hasMetric\n}\n\nfragment ContributingProjectsSummary on ProjectConnection {\n  edges {\n    node {\n      archived\n      owner {\n        aaid\n        id\n      }\n      members {\n        edges {\n          node {\n            aaid\n            id\n          }\n        }\n      }\n      state {\n        value\n      }\n      id\n    }\n  }\n}\n\nfragment CreateOrSelectForm on Goal {\n  ...RollupMetricForm\n  goalType {\n    kind\n    id\n  }\n}\n\nfragment FreeformNumberField on NumberCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on CustomFieldDefinitionNode {\n      __isCustomFieldDefinitionNode: __typename\n      name\n      description\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  value {\n    id\n    numberValue: value\n  }\n}\n\nfragment FreeformTextField on TextCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on CustomFieldDefinitionNode {\n      __isCustomFieldDefinitionNode: __typename\n      name\n      description\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  value {\n    id\n    textValue: value\n  }\n}\n\nfragment GoalActions on Goal {\n  id\n  ari\n  name\n  capabilities {\n    canArchiveGoal\n  }\n  ...ArchiveGoal_goalActions\n}\n\nfragment GoalDatePicker on Goal {\n  id\n  canPostUpdate\n  state {\n    value\n  }\n  targetDate\n  targetDateConfidence\n}\n\nfragment GoalFocusAreas_sidebar on Goal {\n  ari\n  goalType {\n    canLinkToFocusArea\n    id\n  }\n}\n\nfragment GoalFollowButton on Goal {\n  id\n  uuid\n  watching\n  capabilities {\n    canWatchGoal\n  }\n}\n\nfragment GoalItem on Goal {\n  ...PlatformGoalIcon\n  ...progressBarMetricTarget\n  ...MetricChart\n  progress {\n    percentage\n  }\n  name\n  key\n  id\n}\n\nfragment GoalMetaActions on Goal {\n  key\n  ...GoalStateAndTargetDate\n  ...GoalFollowButton\n  ...GoalActions\n}\n\nfragment GoalName on Goal {\n  uuid\n  id\n  key\n  ...PlatformGoalIcon\n  name\n}\n\nfragment GoalOwner on Goal {\n  id\n  ari\n  canEditMembers\n  owner {\n    aaid\n    pii {\n      name\n      picture\n      accountStatus\n      email\n    }\n    ...UserAvatar\n    id\n  }\n}\n\nfragment GoalProgressEditor on Goal {\n  id\n  progress {\n    percentage\n    type\n  }\n  subGoals {\n    count\n  }\n  latestUserUpdate {\n    metricUpdate {\n      edges {\n        node {\n          newValue {\n            time\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  metricTargets {\n    edges {\n      node {\n        id\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n          source\n          latestValue {\n            time\n            value\n            id\n          }\n        }\n        metricTargetPeriods {\n          edges {\n            node {\n              date {\n                dateRange {\n                  start\n                }\n              }\n              value\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment GoalProjects on Goal {\n  id\n  archived\n  projects(tql: \"archived = false\", first: 200) {\n    edges {\n      node {\n        id\n      }\n    }\n    ...ProjectTable\n    ...ContributingProjectsSummary\n  }\n  ...LinkGoalProject\n}\n\nfragment GoalSidebar_1QTvbf on Goal {\n  ari\n  id\n  key\n  goalType {\n    id\n    canLinkToFocusArea\n  }\n  ...parentGoalTypeRestrictions_GoalSidebar\n  ...subGoalTypeRestrictions_GoalSidebar\n  ...metricInfoSection\n  ...GoalOwner\n  ...ParentGoal\n  ...SubGoals\n  ...Teams_1QTvbf\n  ...GoalStartDate\n  ...GoalType\n  ...GoalFocusAreas_sidebar\n  ...GoalTags_sidebar\n  customFields {\n    ...SidebarFields\n  }\n  capabilities {\n    canCreateUpdates\n    canEditMetadata\n  }\n}\n\nfragment GoalStartDate on Goal {\n  startDate\n  ...GoalStartDatePicker\n}\n\nfragment GoalStartDatePicker on Goal {\n  id\n  startDate\n  targetDate\n  creationDate\n  state {\n    value\n  }\n}\n\nfragment GoalState on GoalState {\n  label(includeScore: false)\n  localizedLabel {\n    messageId\n  }\n  score\n  value\n  atCompletionState {\n    label(includeScore: false)\n    localizedLabel {\n      messageId\n    }\n    value\n    score\n  }\n}\n\nfragment GoalStateAndTargetDate on Goal {\n  id\n  canPostUpdate\n  state {\n    value\n    score\n    atCompletionState {\n      value\n      score\n    }\n  }\n  ...GoalDatePicker\n}\n\nfragment GoalSubGoals on Goal {\n  id\n  ari\n  subGoals {\n    edges {\n      node {\n        id\n        archived\n        capabilities {\n          canAddLinkedProjects\n          canRemoveLinkedProjects\n        }\n        ...GoalSummaryPanel\n        ...CompactGoalSummaryPanel\n        ...GoalProjects\n      }\n    }\n  }\n}\n\nfragment GoalSummaryPanel on Goal {\n  ...GoalName\n  state {\n    ...GoalState\n  }\n  dueDate {\n    ...TargetDate\n  }\n  owner {\n    ...UserAvatar_2aqwkz\n    id\n  }\n  ...progressBarMetricTarget\n  ...hasMetric\n}\n\nfragment GoalTags_sidebar on Goal {\n  id\n  tags {\n    ...Tags\n  }\n}\n\nfragment GoalTeamByline_1QTvbf on Team {\n  teamId\n  projects(tql: $teamTql) {\n    count\n  }\n}\n\nfragment GoalType on Goal {\n  goalType {\n    ...goalTypeName\n    ...PlatformGoalTypeIcon\n    id\n  }\n}\n\nfragment LinkGoalProject on Goal {\n  id\n  projects(tql: \"archived = false\", first: 200) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n\nfragment MetricChart on Goal {\n  ...WrappedWithMetricPopup\n  id\n  progress {\n    type\n    percentage\n  }\n  subGoals {\n    count\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        metric {\n          source\n          latestValue {\n            time\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment ParentGoal on Goal {\n  id\n  ari\n  accessLevel\n  parentGoal {\n    id\n    archived\n    accessLevel\n    ...GoalItem\n    goalType {\n      ...goalTypeName\n      kind\n      id\n    }\n  }\n  goalType {\n    requiresParentGoal\n    kind\n    id\n  }\n  ...RestrictedGoalUnlinkModal\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment PlatformGoalTypeIcon on GoalType {\n  icon {\n    key\n  }\n}\n\nfragment ProjectIcon on Project {\n  private\n  icon {\n    id\n    shortName\n  }\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectTable on ProjectConnection {\n  edges {\n    node {\n      id\n      newPhase {\n        _id: id\n      }\n      ...ProjectTableRow\n      ...ProjectTableCompactRow\n    }\n  }\n}\n\nfragment ProjectTableCompactRow on Project {\n  id\n  key\n  name\n  state {\n    ...ProjectState\n  }\n  ...ProjectIcon\n}\n\nfragment ProjectTableRow on Project {\n  id\n  owner {\n    id\n    ...UserAvatar_2aqwkz\n  }\n  ...ProjectName_data\n  dueDate {\n    ...TargetDate\n  }\n  state {\n    ...ProjectState\n  }\n}\n\nfragment RemoveTeam on GoalTeamEdge {\n  canRemove\n  node {\n    teamId\n    id\n  }\n}\n\nfragment RestrictedGoalUnlinkModal on Goal {\n  name\n}\n\nfragment RollupMetricForm on Goal {\n  subGoals {\n    edges {\n      node {\n        archived\n        ...GoalName\n        id\n      }\n    }\n  }\n}\n\nfragment SelectField on TextSelectCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on TextSelectCustomFieldDefinition {\n      name\n      description\n      canSetMultipleValues\n      allowedValues {\n        edges {\n          node {\n            id\n            value\n          }\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  values {\n    edges {\n      node {\n        id\n        value\n      }\n    }\n  }\n}\n\nfragment SidebarFields on CustomFieldConnection {\n  edges {\n    node {\n      __typename\n      ... on TextCustomField {\n        ...FreeformTextField\n      }\n      ... on NumberCustomField {\n        ...FreeformNumberField\n      }\n      ... on UserCustomField {\n        ...UserField\n      }\n      ... on TextSelectCustomField {\n        ...SelectField\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment SubGoals on Goal {\n  id\n  ari\n  accessLevel\n  goalType {\n    kind\n    allowedChildTypes {\n      edges {\n        node {\n          __typename\n          id\n        }\n      }\n    }\n    id\n  }\n  subGoals {\n    edges {\n      node {\n        id\n        archived\n        ...GoalItem\n        goalType {\n          kind\n          requiresParentGoal\n          id\n        }\n        accessLevel\n      }\n    }\n  }\n  ...RestrictedGoalUnlinkModal\n  ...GoalSubGoals\n}\n\nfragment Tag on Tag {\n  ...Tag_createTagOption\n}\n\nfragment Tag_createTagOption on Tag {\n  id\n  name\n  uuid\n  description\n  projectUsageCount\n  goalUsageCount\n  helpPointerUsageCount\n  watcherCount\n}\n\nfragment Tags on TagConnection {\n  edges {\n    node {\n      id\n      uuid\n      name\n      ...Tag\n      ...Tag_createTagOption\n    }\n  }\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment TeamAvatar on Team {\n  id\n  name\n  teamId\n  teamDetails {\n    isVerified\n  }\n  avatarUrl\n}\n\nfragment TeamAvatarWithFollowButton on Team {\n  id\n  teamId\n  name\n  watching\n  ...TeamAvatar\n}\n\nfragment Teams_1QTvbf on Goal {\n  id\n  key\n  canEditMembers\n  teamsV2(first: 20) {\n    edges {\n      node {\n        teamId\n        name\n        ...TeamAvatarWithFollowButton\n        ...GoalTeamByline_1QTvbf\n        id\n        __typename\n      }\n      ...RemoveTeam\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment UserAvatar_1TWJ92 on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n    extendedProfile {\n      jobTitle\n    }\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n\nfragment UserField on UserCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on UserCustomFieldDefinition {\n      name\n      description\n      canSetMultipleValues\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  values {\n    edges {\n      node {\n        id\n        aaid\n        ...UserAvatar_1TWJ92\n      }\n    }\n  }\n}\n\nfragment WrappedWithMetricPopup on Goal {\n  id\n  progress {\n    type\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment common_metricTarget_direct on MetricTarget {\n  startValue\n  targetValue\n  snapshotValue {\n    value\n    id\n  }\n  metric {\n    id\n    name\n    type\n    subType\n  }\n}\n\nfragment dropdownMenu on Goal {\n  accessLevel\n}\n\nfragment goalTypeName on GoalType {\n  name {\n    __typename\n    ... on GoalTypeCustomName {\n      value\n    }\n    ... on LocalizationField {\n      messageId\n      defaultValue\n    }\n  }\n}\n\nfragment goalTypeNamePlural on GoalType {\n  ...goalTypeName\n  namePlural {\n    __typename\n    ... on GoalTypeCustomNamePlural {\n      value\n    }\n    ... on LocalizationField {\n      messageId\n      defaultValue\n    }\n  }\n}\n\nfragment hasMetric on Goal {\n  progress {\n    type\n  }\n  metricTargets {\n    edges {\n      node {\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment inlineCurrentValueUpdate on Goal {\n  id\n  metricTargets {\n    edges {\n      node {\n        id\n        snapshotValue {\n          value\n          id\n        }\n        metric {\n          id\n          type\n          subType\n        }\n      }\n    }\n  }\n}\n\nfragment metricInfoSection on Goal {\n  id\n  uuid\n  progress {\n    type\n  }\n  ...hasMetric\n  ...metricInfoSectionContent\n  ...useShouldHideProgressField\n  ...AddMetricButtonPopup\n  ...GoalProgressEditor\n}\n\nfragment metricInfoSectionContent on Goal {\n  id\n  ...inlineCurrentValueUpdate\n  ...progressBarMetricTarget\n  ...hasMetric\n  ...MetricChart\n  ...ChangeRollupTypePopup\n  ...dropdownMenu\n  progress {\n    type\n    percentage\n  }\n  goalType {\n    successMeasure {\n      state\n      id\n      ...goalTypeName\n      ...goalTypeNamePlural\n    }\n    id\n    kind\n  }\n  subGoals {\n    edges {\n      node {\n        progress {\n          percentage\n        }\n        goalType {\n          kind\n          id\n        }\n        archived\n        id\n      }\n    }\n  }\n  successMeasures(first: 50) {\n    edges {\n      node {\n        progress {\n          percentage\n          type\n        }\n        archived\n        goalType {\n          ...goalTypeName\n          ...goalTypeNamePlural\n          id\n        }\n        id\n      }\n    }\n    pageInfo {\n      hasNextPage\n    }\n  }\n  parentGoal {\n    id\n    ari\n  }\n  metricTargets {\n    edges {\n      node {\n        id\n        ari\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          id\n          ari\n          archived\n          uuid\n          name\n          type\n          subType\n        }\n      }\n    }\n  }\n}\n\nfragment metricInfoSectionNewLozenge on Query {\n  currentUser {\n    onboarding(first: 1, filter: {keys: [GOALS_METRICS_POPUP]}) {\n      edges {\n        node {\n          key\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment parentGoalTypeRestrictions_GoalSidebar on Goal {\n  goalType {\n    allowedParentTypes {\n      edges {\n        node {\n          ari\n          name {\n            __typename\n            ... on GoalTypeCustomName {\n              value\n            }\n            ... on LocalizationField {\n              messageId\n              defaultValue\n            }\n          }\n          icon {\n            key\n          }\n          requiresParentGoal\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment progressBarMetricTarget on Goal {\n  progress {\n    type\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          type\n          subType\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment subGoalTypeRestrictions_GoalSidebar on Goal {\n  goalType {\n    allowedChildTypes {\n      edges {\n        node {\n          ari\n          name {\n            __typename\n            ... on GoalTypeCustomName {\n              value\n            }\n            ... on LocalizationField {\n              messageId\n              defaultValue\n            }\n          }\n          icon {\n            key\n          }\n          requiresParentGoal\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment useShouldHideProgressField on Goal {\n  goalType {\n    allowedChildTypes {\n      edges {\n        node {\n          kind\n          id\n        }\n      }\n    }\n    kind\n    id\n  }\n  successMeasures(first: 50) {\n    edges {\n      node {\n        goalType {\n          kind\n          id\n        }\n        id\n      }\n    }\n  }\n  progress {\n    type\n  }\n}\n"
  }
};
})();

(node as any).hash = "b309e5dcb364247084f8612865cb652e";

export default node;
